import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-not-found',
  templateUrl: './fh-svg-not-found.component.html',
  styleUrl: './fh-svg-not-found.component.scss'
})
export class FhSvgNotFoundComponent {
  @Input() color: string = '';
}
